/* this file added by Bearer Web Developer  */
import React from 'react';
import { useMediaQuery } from '@mui/material';
import ShortcutOrders from '../map/BearerMapApi/shortcutOrders';
import { observer } from 'mobx-react-lite';
import { useAppState } from '../../states/app-state';
import { ShortcutReservedOrdersPlan } from '../../states/reservedOrdersState';
const ShortcutOrdersManagement: React.FC = observer(() => {
    const appState = useAppState();
    const { ReservedOrders } = appState;
    const { shortcutReservedOrdersPlan: plan } = ReservedOrders;
    const isMobile = useMediaQuery("(max-width:834px)"); // 900px max width
    return (<>
        {
            isMobile &&
            (plan === ShortcutReservedOrdersPlan.ShowAtFirstForPlanB || plan === ShortcutReservedOrdersPlan.B)
            && <ShortcutOrders />
        }
    </>)
})
export default ShortcutOrdersManagement;